<template>
    <div>
      <el-button type="primary" @click="show">
        查看模板json
      </el-button>
      <el-dialog :visible.sync="visible"
               @cancel="hideModal">
        <el-row v-loading="spinning"  style="min-height: 100px">
          <el-input type="textarea" style="width:40vw;height:50vh" :value="jsonOut"/>
        </el-row>
        <template slot="title">
          <el-row>
            <div style="margin-right: 20px">JSON</div>
            <el-switch checked-children="tid模式" un-checked-children="默认" :checked="tidMode"
                      @change="onModeChange"/>
            <el-switch checked-children="美化" un-checked-children="压缩" :checked="beautify"
                      @change="onModeChange"/>
          </el-row>
        </template>
        <template slot="footer">
          <el-button key="close" type="info" @click="hideModal">
            关闭
          </el-button>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: "JSONView",
    props: {
      template: {
        type: Object,
      }
    },
    data() {
      return {
        visible: false,
        spinning: true,
        jsonOut: "",
        tidMode: false,
        beautify: false,
      }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
    },
    methods: {
      hideModal() {
        this.visible = false
      },
      show() {
        this.visible = true
        this.spinning = true
        setTimeout(() => {
          let json = this.tidMode ? this.template.getJsonTid() : this.template.getJson();
          let beautify = this.beautify ? 2 : 0;
          this.jsonOut = JSON.stringify(json, null, beautify);
          this.spinning = false
        }, 500)
      },
      onModeChange() {
        this.show();
      }
    }
  }
  
  </script>
  <style lang="less" scoped>
  /deep/ .ant-modal-body {
    padding: 0px;
  }
  
  /deep/ .ant-modal-content {
    margin-bottom: 24px;
  }
  </style>
  